
  <template>
    <div :style="getPaddingStyle()">
      <hr :style="getLineStyle()" />
    </div>
  </template>
  
  <script>
  export default {
    name: 'DividerBlock',
    props: {
      data: Object,
    },
    methods: {
      getPaddingStyle() {
        if (!this.data || !this.data.style || !this.data.style.padding) return {};
        return {
          padding: `${this.data.style.padding.top}px ${this.data.style.padding.right}px ${this.data.style.padding.bottom}px ${this.data.style.padding.left}px`,
        };
      },
      getLineStyle() {
        if (!this.data || !this.data.props) return {};
        return {
          width: '100%',
          border: 'none',
          borderTop: `${this.data.props.lineHeight || 1}px solid ${this.data.props.lineColor || '#CCCCCC'}`,
          margin: '0',
        };
      },
    },
  };
  </script>
  
  